import angular from 'angular';
import { UButtonGroupComponent } from '@updater/angular-common';
import config from './moves.config';
import { AccountMovesComponent } from './moves.component';
import { NewMoveModule } from './new';
import { ConfirmMoveModule } from './confirm';
import { MovesSummaryModule } from './summary';
import services from '../../common/services';
import filters from '../../common/filters';
import { SuffixSelectModule } from '../../common/directives/suffix-select';

import { BackToDashboardButtonComponent } from '../../common/directives/back-to-dashboard-button';

import './moves.global.css';

export const AccountMovesModule = angular
  .module('app.account.moves', [
    MovesSummaryModule.name,
    ConfirmMoveModule.name,
    filters.name,
    NewMoveModule.name,
    services.name,
    UButtonGroupComponent.name,
    BackToDashboardButtonComponent.name,
    SuffixSelectModule.name,
  ])
  .config(config)
  .component('updAccountMoves', AccountMovesComponent);
